import { render, staticRenderFns } from "./HeaderBlog.vue?vue&type=template&id=e097c3f4"
import script from "./HeaderBlog.vue?vue&type=script&lang=js"
export * from "./HeaderBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports